var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loadStatus)?_c('Loading',{attrs:{"text":"Loading..."}}):_vm._e(),(_vm.loadStatus)?[_c('div',{staticClass:"flex items-center search-region"},[_c('div',{staticClass:"search-holder"},[_c('Search',{attrs:{"placeholder":"search by name"},on:{"input":value => (_vm.searchQuery = value)}})],1)]),(_vm.projectsList.length)?_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.projectColumns,"rows":_vm.resultQuery,"styleClass":"vgt-table striped","pagination-options":{
          enabled: false,
          mode: 'records',
          perPage: 50,
          perPageDropdown: [10, 15, 20],
          dropdownAllowAll: false,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
          pageLabel: 'page',
          allLabel: 'All'
        }},scopedSlots:_vm._u([{key:"table-row",fn:function(projectsList){return [(projectsList.column.field === 'inHandsDate')?_c('div',[_vm._v("\n            "+_vm._s(projectsList.row.inHandsDate
                ? _vm.defaultFormatAndParse(projectsList.row.inHandsDate)
                : 'N/A')+"\n          ")]):(projectsList.column.field === 'detailsUrl')?_c('span',[_c('router-link',{staticClass:"hoverable-text font-bold inter",attrs:{"to":{
                name: 'ProjectDetail',
                params: { id: projectsList.row.id }
              }}},[_vm._v("View Details")])],1):(projectsList.column.field === 'state')?_c('span',[_vm._v("\n            "+_vm._s(_vm.formatState(projectsList.row.state))+"\n          ")]):_vm._e()]}}],null,false,1378384427)})],1):_c('div',[_c('ProjectsListZeroState')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }